<div class="page">

  <div class="header">
    <h2>My Leaves</h2>

    <button mat-raised-button color="primary" (click)="openDialog()">
      + Add Leave
    </button>
  </div>

  <div class="table-container">
    <table mat-table [dataSource]="dataSource">

      <ng-container matColumnDef="employer">
        <th mat-header-cell *matHeaderCellDef>Employer</th>
        <td mat-cell *matCellDef="let row">{{ row.employer.name }}</td>
      </ng-container>

      <ng-container matColumnDef="leaveDate">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let row">{{ row.dateHappened }}</td>
      </ng-container>

      <ng-container matColumnDef="days">
        <th mat-header-cell *matHeaderCellDef>Days</th>
        <td mat-cell *matCellDef="let row">{{ row.numberOfDays }}</td>
      </ng-container>

      <ng-container matColumnDef="currentBalance">
        <th mat-header-cell *matHeaderCellDef>Balance</th>
        <td mat-cell *matCellDef="let row">{{ row.currentBalance }}</td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Description</th>
        <td mat-cell *matCellDef="let row">{{ row.description }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> Actions </th>

        <td mat-cell *matCellDef="let row">
          <button mat-icon-button color="warn" (click)="openConfirmDialog(row)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns"></tr>

    </table>
  </div>
</div>
